import { innerSearch } from 'api/Api';
import LoadingIndicator from 'app/components/LoadingIndicator';
import PayverseDirectHeader from 'app/components/PayverseDirectHeader';
import QRCode from 'qrcode.react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';

const DirectQRCodePage = () => {
  const [qrUrl, setQrUrl] = useState<string>();
  const [loading, setLoading] = useState<boolean>(true);
  const { t, i18n } = useTranslation();
  const [tid, setTid] = useState('');
  const navigate = useNavigate();
  // 초기 시간 2분 = 120초
  const initialTime = 120;
  const [timeLeft, setTimeLeft] = useState(initialTime);
  const [apiRequestInterval, setApiRequestInterval] = useState<any>(null);

  useEffect(() => {
    i18n.changeLanguage('cnsi');
  }, [i18n]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const qrcodeUrl = urlParams.get('payUrl');
    const qrcodeTid = urlParams.get('tid');

    if (qrcodeUrl !== null) {
      setQrUrl(qrcodeUrl);
    }
    if (qrcodeTid !== null) {
      setTid(qrcodeTid);
    }
  }, []);

  useEffect(() => {
    if (qrUrl && qrUrl !== undefined) {
      setLoading(false);
    }
  }, [qrUrl]);

  const transactPolling = useMutation(() => innerSearch(tid), {
    onSuccess: data => {
      //Status 예외처리
      if (
        data.data.response.resultStatus === null ||
        data.data.response.resultStatus === undefined
      ) {
        navigate('/error');
        return;
      }
      if (data.data.response.resultStatus === 'SUCCESS') {
        window.close();
      }
    },
    onError: error => {
      navigate('/error');
    },
  });

  useEffect(() => {
    if (timeLeft > 0) {
      const timerId = setInterval(() => {
        setTimeLeft(prevTime => prevTime - 1);
      }, 1000);

      return () => clearInterval(timerId);
    }
  }, [timeLeft]);

  useEffect(() => {
    const interval = setTimeout(() => {
      transactPolling.mutate();
      setApiRequestInterval(false);
    }, 5000);

    return () => {
      if (!apiRequestInterval) {
        clearTimeout(interval);
      }
    };
  }, [apiRequestInterval]);

  useEffect(() => {
    // 5초마다 API 요청을 보냄
    if (timeLeft <= 95 && timeLeft > 0) {
      setApiRequestInterval(true);
    } else if (timeLeft === 0) {
      window.close();
      setApiRequestInterval(false);
    } else {
      setApiRequestInterval(false);
    }
  }, [timeLeft, apiRequestInterval]);

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds
      .toString()
      .padStart(2, '0')}`;
  };

  return (
    <div className="payverse-wrap">
      <div className="payverse">
        <PayverseDirectHeader />
        <div style={{ height: 'calc(100% - 90px' }}>
          <div
            style={{
              flexDirection: 'column',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {loading ? (
              <LoadingIndicator />
            ) : (
              qrUrl && (
                <>
                  <img
                    src="./image/common/schemeList/CN/WECHAT-QR.png"
                    alt=""
                    width={200}
                    style={{ marginBottom: 20 }}
                  />
                  <div
                    style={{
                      border: '2px solid #1EA939',
                      padding: '10px 10px',
                      borderRadius: 10,
                    }}
                  >
                    <QRCode
                      value={qrUrl}
                      style={{ width: '180px', height: '180px' }}
                    />
                  </div>
                  <div
                    style={{
                      color: timeLeft <= 30 ? 'red' : 'gray',
                      marginTop: 20,
                    }}
                  >
                    {t('scan_qr_code')} {formatTime(timeLeft)}
                  </div>
                  <div
                    className="title"
                    style={{
                      marginTop: 10,
                      fontSize: 18,
                      padding: '10px 40px',
                      borderRadius: 10,
                      color: 'gray',
                    }}
                  >
                    {t('scan_qr_code_expires')}
                  </div>
                </>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DirectQRCodePage;
